import Image from "next/image";

import { useTheme } from "@mui/material";

import { useMediaQueryBreakpoint } from "@hooks/useMediaQueryBreakpoint";

import {
  BlurBox,
  BackgroundContainer,
  ImageContainer,
} from "./Background.styled";

interface BackgroundProps {
  withBlurBoxes?: boolean;
}

export const Background = ({ withBlurBoxes }: BackgroundProps) => {
  const { isTablet, isDesktop, isDesktopXl } = useMediaQueryBreakpoint();
  const { portfolio, background } = useTheme();

  return (
    <BackgroundContainer>
      <ImageContainer>
        <Image
          className="background-desktop-xl"
          src={background.image}
          alt=""
          width={1500}
          height={1150}
          quality={100}
          priority
        />
        <Image
          className="background-desktop"
          src={background.image}
          alt=""
          width={1500}
          height={1000}
          quality={100}
          priority
        />
        <Image
          className="background-tablet"
          src={background.image}
          alt=""
          width={1500}
          height={1000}
          quality={100}
          priority
        />
        <Image
          className="background-mobile"
          src={background.image}
          alt=""
          width={750}
          height={850}
          quality={100}
          priority
        />
      </ImageContainer>

      {withBlurBoxes && (
        <>
          <BlurBox width="20%" height="560px" top="440px" left="0px" />

          <BlurBox width="30%" height="560px" top="1500px" left="70%" />

          <BlurBox width="45%" height="360px" top="2000px" left="0" />
        </>
      )}
    </BackgroundContainer>
  );
};
